import { useCallback, useEffect, useState } from 'react';
import { Observable } from '../../Data/Observable/Observable';
const navigationContainerRefObs = new Observable(null);
export function useNavigationContainerRef() {
    const [navigationContainerRef, setNavigationContainerRef] = useState(navigationContainerRefObs.value);
    useEffect(() => {
        const sub = navigationContainerRefObs.subscribe(setNavigationContainerRef);
        return () => sub.unsubscribe();
    }, []);
    const updateRef = useCallback((ref) => {
        ref && navigationContainerRefObs.next(ref);
    }, []);
    return [navigationContainerRef, updateRef];
}
export function getNavigationContainerRef() {
    return navigationContainerRefObs;
}
